module.exports = __webpack_public_path__ + "img/czleader1.e72ff7be.png";